import { useContext, useRef, useState } from 'react'
import Typography from '@mui/material/Typography'
import { Box, Skeleton, Tooltip } from '@mui/material'
import Image from '@components/Image'
import { colorSelection } from '@utils/colorSelection'
import { CustomizedSwitch } from '@components/customized/switch'
import { VariableSizeList as List } from 'react-window'
import AutoSizer from 'react-virtualized-auto-sizer'
import { BsQuestionSquare } from 'react-icons/bs'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import { AuthContext } from '@contexts/Auth'

export default function CustomizedAccordions({
	list,
	selectedGroups,
	setSelectedGroups,
}: {
	list:
		| {
				code?: any
				title?: string
				contents?: any
		  }[]
		| null
	selectedGroups: string[]
	setSelectedGroups: any
}) {
	const { state, dispatch } = useContext(AuthContext)

	const [openElemlist, setOpenElemlist] = useState<number[]>([])

	const hadnleOpen = (itemIndex: number) => {
		if (openElemlist.includes(itemIndex)) {
			let newOpenElemlist = [...openElemlist]
			const _index = openElemlist.indexOf(itemIndex)
			if (_index > -1) {
				newOpenElemlist.splice(_index, 1)
			}
			setOpenElemlist(newOpenElemlist)
			listRef.current.resetAfterIndex(itemIndex, true)
		} else {
			setOpenElemlist([...openElemlist, itemIndex])
			listRef.current.resetAfterIndex(itemIndex, true)
		}
	}

	const getItemSize = (index: number) => {
		if (openElemlist.includes(index) && list) {
			return 44 + list[index]?.contents.length * 71
		} else {
			return 44
		}
	}
	console.debug(list)
	const listRef: any = useRef(null)

	const selectedGroupsFromPermissionTable = [...selectedGroups]

	const renderIsSelected = (roleId: string) => {
		const isSelected = selectedGroupsFromPermissionTable.find((x: string) => x === roleId)
		return !!isSelected
	}

	const Row = ({ index, style }: any) => {
		const isOpen = openElemlist.includes(index)

		style = {
			...style,
			display: 'flex',
			flexDirection: 'column',
			justifycontent: 'center',
			alignItems: 'center',
		}
		return (
			<Box sx={style} key={list && list[index].title} onClick={() => hadnleOpen(index)}>
				<Box
					sx={{
						backgroundColor: '#707070',
						height: '43px',
						color: '#FFFFFF',
						width: '100%',
						display: 'flex',
						justifyContent: 'space-between',
						alignItems: 'center',
					}}
				>
					<Tooltip title={list && list[index].title} followCursor={true}>
						<Typography
							variant="h2"
							sx={{
								marginX: '40px',
								whiteSpace: 'noWrap',
								overflow: 'hidden',
								textOverflow: 'ellipsis',
							}}
						>
							{list && list[index].title}
						</Typography>
					</Tooltip>
					{isOpen ? (
						<KeyboardArrowUpIcon fontSize={'large'} sx={{ marginX: '20px' }} />
					) : (
						<KeyboardArrowDownIcon fontSize={'large'} sx={{ marginX: '20px' }} />
					)}
				</Box>
				{isOpen && (
					<>
						{list &&
							list[index].contents?.map((role: any, i: number) => {
								return (
									<Box
										onClick={(e) => e.stopPropagation()}
										key={i}
										sx={{
											border: '0.3px solid lightgrey',
											display: 'flex',
											flexDirection: 'row',
											justifyContent: 'space-between',
											paddingLeft: '42px',
											paddingRight: '16px',
											alignItems: 'center',
											height: '72px',
											width: '100%',
										}}
									>
										<Tooltip title={role.roleName} followCursor={true}>
											<Box
												sx={{
													gridRow: '1',
													width: '140px',
													height: '20px',
													whiteSpace: 'noWrap',
													overflow: 'hidden',
													textOverflow: 'ellipsis',
												}}
											>
												{role.roleName}
											</Box>
										</Tooltip>
										{/* <Tooltip title={list[index].title} followCursor={true}>
											<Box
												sx={{
													gridRow: '1',
													width: '300px',
													height: '20px',
													whiteSpace: 'noWrap',
													overflow: 'hidden',
													textOverflow: 'ellipsis',
												}}
											>
												{list[index].title}
											</Box>
										</Tooltip> */}
										{/* <Box sx={{ gridRow: '1', width: '200px', height: '20px' }}>
											{state.userInfo.is_super_admin && projectAccess(role.productAccess)}
										</Box> */}
										<Box sx={{ gridRow: '1' }}>
											<CustomizedSwitch
												size="small"
												checked={renderIsSelected(role.id)}
												onChange={(_, checked) => {
													if (checked) {
														setSelectedGroups([...selectedGroups, role.id])
													} else {
														let _index = [...selectedGroups].indexOf(role.id)
														if (_index !== -1) {
															let _selectedGroups = [...selectedGroups]
															_selectedGroups.splice(_index, 1)
															setSelectedGroups(_selectedGroups)
														}
													}
												}}
											/>
										</Box>
									</Box>
								)
							})}
					</>
				)}
			</Box>
		)
	}

	return (
		<Box sx={{ height: '513px' }}>
			{list ? (
				<AutoSizer>
					{({ height, width }: any) => (
						<List
							height={height}
							width={width}
							itemCount={list?.length}
							itemSize={getItemSize}
							ref={listRef}
							key={
								list &&
								list[0]?.code +
									list[0]?.contents?.length +
									list[list.length - 1]?.code +
									list[list.length - 1]?.contents?.length +
									list.length
							}
						>
							{Row}
						</List>
					)}
				</AutoSizer>
			) : (
				[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((x) => {
					return (
						<Skeleton
							key={`skeleton_${x}`}
							variant="rectangular"
							width={'100%'}
							height={44}
							sx={{ marginY: '1px' }}
						/>
					)
				})
			)}
		</Box>
	)
}
